import { IntegrityMonitorAssignRulesFormGzDataProvider } from '../dataProvider/IntegrityMonitorAssignRulesFormGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class IntegrityMonitorAssignRulesFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorAssignRulesFormGzDataProvider);
  }
}
